export const API_KEY='G6DPTP1-S0X4EQ4-J2RV136-J4SD0W3';

export const SAUTI_PRODUCT_CATEGORIES = [
    'Animal Products', 'Beans', 'Cereals - Maize', 'Cereals - Other',
    'Cereals - Rice', 'Fruits', 'Other', 'Peas', 'Roots & Tubers',
    'Seeds & Nuts', 'Vegetables']

export const SAUTI_PRODUCT_SUBCATEGORIES = [
    {category: 'Animal Products', subcategory: 'Animal Products'},
    {category: 'Animal Products', subcategory: 'Livestock'},
    {category: 'Animal Products', subcategory: 'Poultry'},
    {category: 'Beans', subcategory: 'Beans'},
    {category: 'Cereals - Maize', subcategory: 'Maize'},
    {category: 'Cereals - Other', subcategory: 'Barley'},
    {category: 'Cereals - Other', subcategory: 'Millet'},
    {category: 'Cereals - Other', subcategory: 'Sorghum'},
    {category: 'Cereals - Other', subcategory: 'Wheat'},
    {category: 'Cereals - Rice', subcategory: 'Rice'},
    {category: 'Fruits', subcategory: 'Avocado'},
    {category: 'Fruits', subcategory: 'Bananas'},
    {category: 'Fruits', subcategory: 'Fruits'},
    {category: 'Fruits', subcategory: 'Lemons'},
    {category: 'Fruits', subcategory: 'Limes'},
    {category: 'Fruits', subcategory: 'Mangoes'},
    {category: 'Fruits', subcategory: 'Oranges'},
    {category: 'Fruits', subcategory: 'Pawpaw'},
    {category: 'Fruits', subcategory: 'Pineapples'},
    {category: 'Other', subcategory: 'Coffee'},
    {category: 'Other', subcategory: 'Cotton'},
    {category: 'Other', subcategory: 'Tea'},
    {category: 'Other', subcategory: 'Tobacco'},
    {category: 'Other', subcategory: 'Vanilla'},
    {category: 'Peas', subcategory: 'Peas'},
    {category: 'Roots & Tubers', subcategory: 'Cassava'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes'},
    {category: 'Seeds & Nuts', subcategory: 'Nuts'},
    {category: 'Seeds & Nuts', subcategory: 'Simsim'},
    {category: 'Seeds & Nuts', subcategory: 'Sunflowers'},
    {category: 'Vegetables', subcategory: 'Brinjals'},
    {category: 'Vegetables', subcategory: 'Cabbages'},
    {category: 'Vegetables', subcategory: 'Capsicums'},
    {category: 'Vegetables', subcategory: 'Carrots'},
    {category: 'Vegetables', subcategory: 'Cauliflower'},
    {category: 'Vegetables', subcategory: 'Chillies'},
    {category: 'Vegetables', subcategory: 'Cucumber'},
    {category: 'Vegetables', subcategory: 'Ginger'},
    {category: 'Vegetables', subcategory: 'Kales'},
    {category: 'Vegetables', subcategory: 'Lettuce'},
    {category: 'Vegetables', subcategory: 'Onions'},
    {category: 'Vegetables', subcategory: 'Tomatoes'},
]
export const SAUTI_PRODUCTS = [
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Eggs'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Exotic Eggs'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Local Eggs'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Milk'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Nile Perch'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Processed Honey'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Tilapia'},
    {category: 'Animal Products', subcategory: 'Animal Products', product: 'Unprocessed Honey'},
    {category: 'Animal Products', subcategory: 'Livestock', product: 'Beef'},
    {category: 'Animal Products', subcategory: 'Livestock', product: 'Goat Meat'},
    {category: 'Animal Products', subcategory: 'Livestock', product: 'Pork'},
    {category: 'Animal Products', subcategory: 'Poultry', product: 'Exotic Chicken'},
    {category: 'Animal Products', subcategory: 'Poultry', product: 'Local Chicken'},
    {category: 'Animal Products', subcategory: 'Poultry', product: 'Turkey'},
    {category: 'Beans', subcategory: 'Beans', product: 'Agwedde Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Beans (K132)'},
    {category: 'Beans', subcategory: 'Beans', product: 'Beans Canadian'},
    {category: 'Beans', subcategory: 'Beans', product: 'Beans Mwitemania'},
    {category: 'Beans', subcategory: 'Beans', product: 'Beans Rosecoco'},
    {category: 'Beans', subcategory: 'Beans', product: 'Black Beans (Dolichos)'},
    {category: 'Beans', subcategory: 'Beans', product: 'Dolichos (Njahi)'},
    {category: 'Beans', subcategory: 'Beans', product: 'Green Gram'},
    {category: 'Beans', subcategory: 'Beans', product: 'Kidney Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Mixed Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Mwezi Moda'},
    {category: 'Beans', subcategory: 'Beans', product: 'Nambale Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Old Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Red Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Soya Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'White Beans'},
    {category: 'Beans', subcategory: 'Beans', product: 'Yellow Beans'},
    {category: 'Cereals - Maize', subcategory: 'Maize', product: 'Dry Maize'},
    {category: 'Cereals - Maize', subcategory: 'Maize', product: 'Green Maize'},
    {category: 'Cereals - Maize', subcategory: 'Maize', product: 'Maize'},
    {category: 'Cereals - Maize', subcategory: 'Maize', product: 'Maize Bran'},
    {category: 'Cereals - Maize', subcategory: 'Maize', product: 'Maize Flour'},
    {category: 'Cereals - Other', subcategory: 'Barley', product: 'Barley'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'Bulrush Millet'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'Finger Millet'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'Millet Flour'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'Millet Grain'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'Pearl Millet'},
    {category: 'Cereals - Other', subcategory: 'Millet', product: 'White Millet'},
    {category: 'Cereals - Other', subcategory: 'Sorghum', product: 'Sorghum'},
    {category: 'Cereals - Other', subcategory: 'Sorghum', product: 'Sorghum Flour'},
    {category: 'Cereals - Other', subcategory: 'Sorghum', product: 'Sorghum Grain'},
    {category: 'Cereals - Other', subcategory: 'Sorghum', product: 'White Sorghum'},
    {category: 'Cereals - Other', subcategory: 'Sorghum', product: 'Red Sorghum'},
    {category: 'Cereals - Other', subcategory: 'Wheat', product: 'Wheat'},
    {category: 'Cereals - Other', subcategory: 'Wheat', product: 'Wheat Bran'},
    {category: 'Cereals - Other', subcategory: 'Wheat', product: 'Wheat Flour'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Imported Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Kahama Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Kayiso Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Kilombero Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Mbeya Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Morogoro Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Paddy Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Rice Bran'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Super Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Unprocessed/husked Rice'},
    {category: 'Cereals - Rice', subcategory: 'Rice', product: 'Upland Rice'},
    {category: 'Fruits', subcategory: 'Avocado', product: 'Avocado'},
    {category: 'Fruits', subcategory: 'Bananas', product: 'Apple Bananas'},
    {category: 'Fruits', subcategory: 'Bananas', product: 'Cavendish (Bogoya)'},
    {category: 'Fruits', subcategory: 'Bananas', product: 'Cooking Bananas'},
    {category: 'Fruits', subcategory: 'Bananas', product: 'Ripe Bananas'},
    {category: 'Fruits', subcategory: 'Fruits', product: 'Passion Fruits'},
    {category: 'Fruits', subcategory: 'Lemons', product: 'Lemons'},
    {category: 'Fruits', subcategory: 'Limes', product: 'Limes'},
    {category: 'Fruits', subcategory: 'Mangoes', product: 'Mangoes Local'},
    {category: 'Fruits', subcategory: 'Mangoes', product: 'Mangoes Ngowe'},
    {category: 'Fruits', subcategory: 'Oranges', product: 'Oranges'},
    {category: 'Fruits', subcategory: 'Pawpaw', product: 'Pawpaw'},
    {category: 'Fruits', subcategory: 'Pineapples', product: 'Pineapples'},
    {category: 'Other', subcategory: 'Coffee', product: 'Coffee (Arabica)'},
    {category: 'Other', subcategory: 'Coffee', product: 'Coffee (Robusta)'},
    {category: 'Other', subcategory: 'Cotton', product: 'Cotton'},
    {category: 'Other', subcategory: 'Tea', product: 'Unprocessed Tea'},
    {category: 'Other', subcategory: 'Tobacco', product: 'Tobacco'},
    {category: 'Other', subcategory: 'Vanilla', product: 'Unprocessed Vanilla'},
    {category: 'Peas', subcategory: 'Peas', product: 'Chic Pea'},
    {category: 'Peas', subcategory: 'Peas', product: 'Cowpeas'},
    {category: 'Peas', subcategory: 'Peas', product: 'Dry Peas'},
    {category: 'Peas', subcategory: 'Peas', product: 'Fresh Peas'},
    {category: 'Peas', subcategory: 'Peas', product: 'Green Peas'},
    {category: 'Peas', subcategory: 'Peas', product: 'Peas'},
    {category: 'Peas', subcategory: 'Peas', product: 'Pigeon Peas'},
    {category: 'Roots & Tubers', subcategory: 'Cassava', product: 'Cassava Chips'},
    {category: 'Roots & Tubers', subcategory: 'Cassava', product: 'Cassava Fresh'},
    {category: 'Roots & Tubers', subcategory: 'Cassava', product: 'Cassava Flour'},
    {category: 'Roots & Tubers', subcategory: 'Cassava', product: 'Dry Fermented Cassava'},
    {category: 'Roots & Tubers', subcategory: 'Cassava', product: 'Sun Dried Cassava'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes', product: 'Red Irish Potatoes'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes', product: 'Round Potatoes'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes', product: 'Sweet Potatoes'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes', product: 'White Fleshed Sweet Potatoes'},
    {category: 'Roots & Tubers', subcategory: 'Potatoes', product: 'White Irish Potatoes'},
    {category: 'Seeds & Nuts', subcategory: 'Nuts', product: 'Ground Nuts'},
    {category: 'Seeds & Nuts', subcategory: 'Nuts', product: 'Groundnuts'},
    {category: 'Seeds & Nuts', subcategory: 'Simsim', product: 'Simsim'},
    {category: 'Seeds & Nuts', subcategory: 'Sunflowers', product: 'Sunflower Seed'},
    {category: 'Seeds & Nuts', subcategory: 'Sunflowers', product: 'Sunflower Seed Cake'},
    {category: 'Vegetables', subcategory: 'Brinjals', product: 'Brinjal/Eggplant'},
    {category: 'Vegetables', subcategory: 'Cabbages', product: 'Cabbages'},
    {category: 'Vegetables', subcategory: 'Capsicums', product: 'Capsicums'},
    {category: 'Vegetables', subcategory: 'Carrots', product: 'Carrots'},
    {category: 'Vegetables', subcategory: 'Cauliflower', product: 'Cauliflower'},
    {category: 'Vegetables', subcategory: 'Chillies', product: 'Chillies'},
    {category: 'Vegetables', subcategory: 'Cucumber', product: 'Cucumber'},
    {category: 'Vegetables', subcategory: 'Ginger', product: 'Ginger'},
    {category: 'Vegetables', subcategory: 'Kales', product: 'Kales'},
    {category: 'Vegetables', subcategory: 'Lettuce', product: 'Lettuce'},
    {category: 'Vegetables', subcategory: 'Onions', product: 'Onions Dry'},
    {category: 'Vegetables', subcategory: 'Onions', product: 'Spring Onions'},
    {category: 'Vegetables', subcategory: 'Tomatoes', product: 'Tomatoes'},
]